import React from 'react';
import styles from './TopBar.module.css';

export default function TopBar({ total, query, onQuery }) {
    return (
        <div className={styles.wrap}>
            <div className={styles.searchCon}>
                <img src='/assets/icons/search.png' height={15} />
                <input
                    value={query}
                    onChange={(e) => onQuery(e.target.value)}
                    placeholder="Search by model, brand, or feature…"
                    className={styles.input}
                />
            </div>
        </div>
    );
}
